module.exports = __webpack_public_path__ + "static/media/EarthID FAVICON - PRIMARY.8b46fa5f.png";